export const ACP_SESSION_TERMINAL_STATUSES = [
    'completed',
    'failed',
    'interrupted',
];
/** Valid state machine transitions for ACP sessions. */
export const ACP_SESSION_VALID_TRANSITIONS = {
    pending: ['assigned'],
    assigned: ['running', 'failed', 'interrupted'],
    running: ['completed', 'failed', 'interrupted'],
    completed: [],
    failed: [],
    interrupted: [],
};
/** Default configurable values for ACP session lifecycle (overridable via env vars). */
export const ACP_SESSION_DEFAULTS = {
    /** VM agent heartbeat frequency (ms). Env: ACP_SESSION_HEARTBEAT_INTERVAL_MS */
    HEARTBEAT_INTERVAL_MS: 60_000,
    /**
     * ProjectData heartbeat stale window (ms). Env: ACP_SESSION_DETECTION_WINDOW_MS.
     * VM-backed sessions require conclusive runtime/workspace evidence before interruption.
     */
    DETECTION_WINDOW_MS: 300_000,
    /** VM agent startup reconciliation timeout (ms). Env: ACP_SESSION_RECONCILIATION_TIMEOUT_MS */
    RECONCILIATION_TIMEOUT_MS: 30_000,
    /** Messages to include in fork context summary. Env: ACP_SESSION_FORK_CONTEXT_MESSAGES */
    FORK_CONTEXT_MESSAGES: 20,
    /** Maximum fork chain length. Env: ACP_SESSION_MAX_FORK_DEPTH */
    MAX_FORK_DEPTH: 10,
};
/** A normal retention outcome; never failure diagnostics. */
export const SNAPSHOT_EXPIRED_REASON = 'snapshot_expired';
export function isExpiredTask(task) {
    return task?.status === 'cancelled' && task.terminalReason === SNAPSHOT_EXPIRED_REASON;
}
//# sourceMappingURL=session.js.map